import png from './images/img-type/png.png'
import defalutImg from './images/img-type/defalutImg.png'
import excel from './images/img-type/excel.png'
import pdf from './images/img-type/pdf.png'
import ppt from './images/img-type/ppt.png'
import word from './images/img-type/word.png'
import zip from './images/img-type/zip.png'
import mp3 from './images/img-type/mp3.png'
import html from './images/img-type/html.png'
import txt from './images/img-type/txt.png'

export const imgSuffixMaps = {
  png,
  jpeg: png,
  defalutImg,
  excel,
  pdf,
  ppt,
  word,
  zip,
  mp3,
  html,
  jpg: png,
  xlsx: excel,
  docx: word,
  gif: png,
  mp4: mp3,
  xls: excel,
  pptx: ppt,
  txt
}

export function getImgSuffixImg(suffix) {
  return imgSuffixMaps[suffix] || imgSuffixMaps.defalutImg
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]'
}



// WEBPACK FOOTER //
// ./src/public/components/kye-image/utils.js